module.exports = {
  "search": "Search",
  "content_hub": "Content Hub",
  "collections": "Collections",
  "conversations": "Conversations",
  "engage": "Engage",
  "reports": "Reports",
  "deal_insights": "Deal Insights",
  "compose": "Compose",
  "settings": "Settings",
  "talk_to_us": "Talk to us",
  "seek": "Seek"
}